import Image from '@atoms/Image';
import Link from '@atoms/Link';
import parseHtml from '@lib/html-parser';
import sanitizeHtml from '@lib/sanitize-html';
import BlogMetaInfo from '../BlogMetaInfo';
import useWindowDimensions from '@hooks/useWindowDimensions';
import AuthorDetails from "@components/Blogs/AuthorDetails";
import { getBlogImageUrlUpdated } from '../helper';

function BlogDetails({ blogDetails, categories, relateBlogs }) {
    const { width } = useWindowDimensions();
    return (
        <div className="flex flex-col items-center">
            <h1 className="skeleton-loader h3-regular md:h2-regular md:text-center mb-4 md:mb-6 xl:mb-8">
                {blogDetails?.title}
            </h1>
            {blogDetails ? (
                <div
                    className={`${blogDetails?.featuredImage?.node?.sourceUrl
                        ? 'h-56 md:h-96 lg:h-107 xl:h-122 md:max-w-[900px] md:min-w-[90%] xl:max-w-[1024px]'
                        : ''
                        } `}
                >
                    <Image
                        src={getBlogImageUrlUpdated(blogDetails?.featuredImage?.node?.sourceUrl)}
                        alt="featuredImage"
                        className="h-full w-full rounded-2xl mb-8 object-cover"
                    />
                </div>
            ) : (
                <section className="skeleton-loader h-56 md:h-80 xl:h-107 mt-4 rounded-b-lg"></section>
            )}
            <div className="md:mx-6 lg:mx-10 xl:mx-15 pt-6 xl:pt-8 w-[-webkit-fill-available]">
                <BlogMetaInfo
                    blogDetails={blogDetails}
                    categories={categories}
                />
                {blogDetails?.content ? (
                    <>
                        <div className={`${width >= 768 ? 'entry-content' : 'entry-content-mobile'} md:font-normal mt-6 xl:mt-8`}>
                            {parseHtml(sanitizeHtml(blogDetails.content))}
                        </div>
                    </>
                ) : (
                    <>
                        <p className="skeleton-loader mt-8 mb-3"></p>
                        <p className="skeleton-loader mb-3"></p>
                        <p className="skeleton-loader mb-3"></p>
                        <p className="skeleton-loader mb-3"></p>
                    </>
                )}

                <hr className='my-8'/>
                {blogDetails?.author ? <AuthorDetails author={blogDetails?.author} /> : null}
            </div>

            {relateBlogs?.length && (
                <div className="flex justify-between text-primary-500 text-sm xl:text-base w-full font-semibold lg:px-6 xl:px-10 mt-2">
                    <Link
                        href={`/blogs/${relateBlogs[relateBlogs.length - 1].slug
                            }`}
                    >
                        <div className="cursor-pointer">
                            <Image
                                src={`/images/Arrow-Right.svg`}
                                className="inline mr-1 h-4 rotate-180"
                            />
                            <div className="hidden md:inline">
                                Go to previous Article
                            </div>
                            <div className="inline md:hidden">Previous</div>
                        </div>
                    </Link>
                    <Link href={`/blogs/${relateBlogs[0].slug}`}>
                        <div className="cursor-pointer">
                            <div className="hidden md:inline">
                                Go to next Article
                            </div>
                            <div className="inline md:hidden">Next</div>
                            <Image
                                src={`/images/Arrow-Right.svg`}
                                className="inline pl-1 h-4"
                            />
                        </div>
                    </Link>
                </div>
            )}
        </div>
    );
}

export default BlogDetails;
